/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateCompetitionBodyFaqsInner
 */
export interface CreateCompetitionBodyFaqsInner {
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyFaqsInner
     */
    question?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCompetitionBodyFaqsInner
     */
    answer?: string;
    /**
     * 
     * @type {number}
     * @memberof CreateCompetitionBodyFaqsInner
     */
    order?: number;
}

/**
 * Check if a given object implements the CreateCompetitionBodyFaqsInner interface.
 */
export function instanceOfCreateCompetitionBodyFaqsInner(value: object): value is CreateCompetitionBodyFaqsInner {
    return true;
}

export function CreateCompetitionBodyFaqsInnerFromJSON(json: any): CreateCompetitionBodyFaqsInner {
    return CreateCompetitionBodyFaqsInnerFromJSONTyped(json, false);
}

export function CreateCompetitionBodyFaqsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCompetitionBodyFaqsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'question': json['question'] == null ? undefined : json['question'],
        'answer': json['answer'] == null ? undefined : json['answer'],
        'order': json['order'] == null ? undefined : json['order'],
    };
}

export function CreateCompetitionBodyFaqsInnerToJSON(json: any): CreateCompetitionBodyFaqsInner {
    return CreateCompetitionBodyFaqsInnerToJSONTyped(json, false);
}

export function CreateCompetitionBodyFaqsInnerToJSONTyped(value?: CreateCompetitionBodyFaqsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'question': value['question'],
        'answer': value['answer'],
        'order': value['order'],
    };
}

